module.exports = __webpack_public_path__ + "static/media/PDF.82670a06.svg";